import React from 'react';
import { FieldArray } from 'redux-form';
import Row from './Row';

import styles from './styles.css';

const List = ({ fields, data, keyAccessor, ...rest }: any) =>
  fields.map((field, i) => (
    <Row
      {...rest}
      key={
        keyAccessor
          ? keyAccessor(fields.get(i))
          : fields.get(i).action + fields.get(i).type + fields.get(i).name + i
      }
      field={field}
      index={i}
      totalRows={fields.length}
      meta={data}
      data={fields.get(i)}
      onRemove={fields.remove}
    />
  ));

export default (props: any) => <FieldArray {...props} component={List} />;
